// extracted by mini-css-extract-plugin
export default {"heroSeller":"FaqSellerPage_heroSeller__nEdYu"};